// Libraries
import * as React from "react"
import { useState, useRef, useEffect } from "react"

// Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter, faSearch } from "@fortawesome/pro-light-svg-icons"
import { faCalendar, faTimes } from "@fortawesome/pro-solid-svg-icons"
import DatePicker from "react-date-picker"

//Context
import MenuContext from "../contexts/menu"

const EventFilters = ({
	filterState,
	setFilterState,
	setHasFilterState,
	hasFilterState,
	setFiltersActive,
	filtersActive,
	filterDropdowns,
	resetFilterState,
	filters,
	setDateFromValue,
	dateFromValue,
	dateFromValueOnChange,
	setDateToValue,
	dateToValue,
	dateToValueOnChange,
	filterDropdownActive,
	setFilterDropdownActive,
	searchArtist,
	searchArtistHandleChange,
}) => {
	const toggleFilterDropdownActive = filterDropdown => {
		if (filterDropdown === "reset") {
			setDateToValue(null)
			setDateFromValue(null)
			resetFilterState()
			setFiltersActive({
				type: false,
				artist: false,
				venue: false,
				date: false,
			})
			setHasFilterState(false)
		} else {
			const dropdownsReset = { type: false, artist: false, venue: false, date: false }
			setFilterDropdownActive({ ...dropdownsReset, [filterDropdown]: !filterDropdownActive[filterDropdown] })
		}
	}

	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	function useOutsideAlerter(ref) {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setFilterDropdownActive(filterDropdowns)
				}
			}
			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	const wrapperRef = useRef(null)
	useOutsideAlerter(wrapperRef)

	function entryClickHandler(filterDropdown, filterValue) {
		if (filterValue === "all") {
			switch (filterDropdown) {
				case "type":
					setFiltersActive({ ...filtersActive, type: false })
					break
				case "artist":
					setFiltersActive({ ...filtersActive, artist: false })
					break
				case "venue":
					setFiltersActive({ ...filtersActive, venue: false })
					break
				default:
					break
			}
			setFilterState({ ...filterState, [filterDropdown]: [] })
		} else {
			//if already in the filter state - remove, otherwise add
			const alreadyExists = filterState[filterDropdown].includes(filterValue)
			if (alreadyExists) {
				//remove from filter state
				const filterStateTemp = filterState[filterDropdown].filter(item => item !== filterValue)
				const isEmpty = filterStateTemp.length === 0

				switch (filterDropdown) {
					case "type":
						if (isEmpty) {
							setFiltersActive({ ...filtersActive, type: false })
						}
						setFilterState({ ...filterState, type: filterStateTemp })
						break
					case "artist":
						if (isEmpty) {
							setFiltersActive({ ...filtersActive, artist: false })
						}
						setFilterState({ ...filterState, artist: filterStateTemp })
						break
					case "venue":
						if (isEmpty) {
							setFiltersActive({ ...filtersActive, venue: false })
						}
						setFilterState({ ...filterState, venue: filterStateTemp })
						break
					default:
						break
				}
			} else {
				switch (filterDropdown) {
					case "type":
						setFiltersActive({ ...filtersActive, type: true })
						setFilterState({
							...filterState,
							type: [...filterState.type.filter(item => item !== "all"), filterValue],
						})
						break
					case "artist":
						setFiltersActive({ ...filtersActive, artist: true })
						setFilterState({ ...filterState, artist: [...filterState.artist, filterValue] })
						break
					case "venue":
						setFiltersActive({ ...filtersActive, venue: true })
						setFilterState({
							...filterState,
							venue: [...filterState.venue.filter(item => item !== "all"), filterValue],
						})
						break
					default:
						break
				}
			}
		}
	}

	let venueAllActive =
		(filterState["venue"].length === 1 && filterState["venue"].includes("all")) || filterState["venue"].length === 0
	let typeAllActive =
		(filterState["type"].length === 1 && filterState["type"].includes("all")) || filterState["type"].length === 0

	const [toggleFilterPanel, setToggleFilterPanel] = useState(false)
	const [toggleFilterPanelZ, setToggleFilterPanelZ] = useState(false)

	const resetFilter = [
		{
			class: "reset",
			name: "Remove all filters",
			active: false,
			showFilterIcon: false,
			options: { list: [], showAll: false },
		},
	]

	return (
		<>
			<MenuContext.Consumer>
				{menuContext => (
					<div
						className={`filters-outer ${toggleFilterPanelZ ? "z-in" : "z-out"} ${toggleFilterPanel ? "mobile-menu-in" : ""}`}
					>
						<div className="filters-toggle-outer container">
							<button
								className="filters-toggle"
								onClick={() => {
									setToggleFilterPanel(!toggleFilterPanel)
									menuContext.menuToggle()
									setToggleFilterPanelZ(!toggleFilterPanel)
								}}
							>
								Filter Events <FontAwesomeIcon icon={faFilter} title="Filter icon" />
							</button>
							<div className="filters-remove-mobile filters">
								<ul className="filter-list">
									{resetFilter.map(filter => (
										<li
											key={"reset-filter"}
											className={`filter ${filter.class} ${hasFilterState && filter.class === "reset" ? "reset-active" : ""} ${filterDropdownActive[filter.class] ? "active" : ""}`}
										>
											<span>
												<button
													className="filter-title"
													onClick={() => {
														toggleFilterDropdownActive(filter.class)
													}}
												>
													{filter.name}
												</button>
											</span>
										</li>
									))}
								</ul>
							</div>
						</div>
						<div className="filters-panel-outer">
							<div className="filters-mobile-menu-backdrop"></div>
							<div className="filters-menu-mobile filters">
								<button
									className="filters-apply-mobile"
									onClick={() => {
										setToggleFilterPanel(false)
										menuContext.menuToggle()
										setTimeout(() => {
											setToggleFilterPanelZ(false)
										}, 300)
									}}
								>
									Apply Filters
								</button>
								<div className="container" ref={wrapperRef}>
									<button
										className="filters-close"
										onClick={() => {
											setToggleFilterPanel(false)
											menuContext.menuToggle()
											setTimeout(() => {
												setToggleFilterPanelZ(false)
											}, 300)
										}}
									>
										<FontAwesomeIcon icon={faTimes} title="Close icon" />
									</button>

									<div className="mob-filter-title-wrapper">
										<h2 className="filter-main-title">Events Filters</h2>
									</div>

									<ul className="filter-list">
										{filters.map((filter, i) => (
											<li
												key={i}
												className={`filter ${filter.class} ${hasFilterState && filter.class === "reset" ? "reset-active" : ""} ${filterDropdownActive[filter.class] ? "active" : ""}`}
											>
												<span>
													<button
														className="filter-title"
														onClick={() => {
															toggleFilterDropdownActive(filter.class)
														}}
													>
														{filter.name}
														{filter.showFilterIcon &&
															filtersActive[filter.class] === true && (
																<span className="filter-active active">
																	<FontAwesomeIcon
																		icon={faFilter}
																		title="Filter icon"
																	/>
																</span>
															)}
													</button>
													{filter.class !== "reset" ? (
														<div className={`filter-dropdown`}>
															{filter.class === "artist" && (
																<div className="filter-artist-mobile event-search-wrap">
																	<input
																		type="text"
																		placeholder="Search artist"
																		className="event-search-wrap__input filters-toggle"
																		value={searchArtist}
																		onChange={searchArtistHandleChange}
																	/>
																	<button
																		className="event-search-wrap__submit"
																		type="submit"
																	>
																		<FontAwesomeIcon
																			icon={faSearch}
																			title="Search"
																		/>
																	</button>
																</div>
															)}
															<div className="filter-dropdown-inner">
																{filter.class === "date" ? (
																	<>
																		<div className="date-picker">
																			<div class="line date-picker-from">
																				<div class="label">From</div>
																				<DatePicker
																					onChange={dateFromValueOnChange}
																					value={dateFromValue}
																					calendarIcon={
																						<FontAwesomeIcon
																							icon={faCalendar}
																							title="Filter icon"
																						/>
																					}
																				/>
																			</div>
																			<div class="line date-picker-from">
																				<div class="label">To</div>
																				<DatePicker
																					onChange={dateToValueOnChange}
																					value={dateToValue}
																					calendarIcon={
																						<FontAwesomeIcon
																							icon={faCalendar}
																							title="Filter icon"
																						/>
																					}
																				/>
																			</div>
																		</div>
																	</>
																) : (
																	<>
																		{filter.class === "type" ||
																		filter.class === "artist" ? (
																			<>
																				{filter.options.showAll ? (
																					<>
																						<div className="filter-all">
																							<div className="filter-all-name"></div>
																							<button
																								className={`all filter-entry ${typeAllActive ? "active" : ""}`}
																								onClick={() => {
																									entryClickHandler(
																										filter.class,
																										"all",
																									)
																								}}
																							>
																								All
																							</button>
																						</div>
																					</>
																				) : (
																					<></>
																				)}
																				{filter.class === "artist" ? (
																					<>
																						{filter.options.list.length >
																						0 ? (
																							<>
																								{filter.options.list.map(
																									group => (
																										<div className="filter-group">
																											<div className="filter-group-name">
																												{
																													group[1]
																														.group
																												}
																											</div>
																											<div className="filter-entries">
																												{group[1].entries.map(
																													entry => {
																														let active =
																															filterState[
																																filter
																																	.class
																															].includes(
																																entry
																																	.artist
																																	.name,
																															)
																														return (
																															<button
																																className={`filter-entry ${active === true ? "active" : ""}`}
																																onClick={() => {
																																	entryClickHandler(
																																		filter.class,
																																		entry
																																			.artist
																																			.name,
																																	)
																																}}
																															>
																																{
																																	entry
																																		.artist
																																		.name
																																}
																															</button>
																														)
																													},
																												)}
																											</div>
																										</div>
																									),
																								)}
																							</>
																						) : (
																							<>
																								<div className="filter-group no-result">
																									<div className="filter-entries">
																										<div className="filter-entry">
																											No Artists
																											found using
																											the search
																											term "
																											{
																												searchArtist
																											}
																											"
																										</div>
																									</div>
																								</div>
																							</>
																						)}
																					</>
																				) : (
																					<></>
																				)}
																				{filter.class === "type" &&
																					filter.options.list.map(
																						eventType => (
																							<div className="filter-group">
																								<div className="filter-group-name">
																									{eventType.name}
																								</div>
																								<div className="filter-entries">
																									{eventType.types.map(
																										entry => {
																											let active =
																												filterState[
																													filter
																														.class
																												].includes(
																													entry.id,
																												)
																											return (
																												<button
																													className={`filter-entry ${active ? "active" : ""}`}
																													onClick={() => {
																														entryClickHandler(
																															filter.class,
																															entry.id,
																														)
																													}}
																												>
																													{
																														entry.name
																													}
																												</button>
																											)
																										},
																									)}
																								</div>
																							</div>
																						),
																					)}
																			</>
																		) : (
																			<></>
																		)}
																		{filter.class === "venue" ? (
																			<>
																				{filter.options.showAll ? (
																					<>
																						<button
																							className={`all filter-entry ${venueAllActive ? "active" : ""}`}
																							onClick={() => {
																								entryClickHandler(
																									filter.class,
																									"all",
																								)
																							}}
																						>
																							All
																						</button>
																					</>
																				) : (
																					<></>
																				)}
																				{filter.options.list.map(entry => {
																					let active = filterState[
																						filter.class
																					].includes(entry.name)
																					return (
																						<button
																							className={`filter-entry ${active ? "active" : ""}`}
																							onClick={() => {
																								entryClickHandler(
																									"venue",
																									entry.name,
																								)
																							}}
																						>
																							{entry.name}
																						</button>
																					)
																				})}
																			</>
																		) : (
																			<></>
																		)}
																	</>
																)}
															</div>
														</div>
													) : (
														<></>
													)}
												</span>
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					</div>
				)}
			</MenuContext.Consumer>
		</>
	)
}

export default EventFilters
